"use client"

import { useState, useEffect } from "react"
import { SafeHtml } from "@/components/ui/safe-html"
import { Skeleton } from "@/components/ui/skeleton"
import { formatDateIST } from '@/lib/client-utils'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { Badge } from "@/components/ui/badge"
import { Separator } from "@/components/ui/separator"

export function ShippingPolicyPage() {
  const [content, setContent] = useState<any>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await fetch('/api/content?type=SHIPPING_POLICY')
        if (response.ok) {
          const data = await response.json()
          setContent(data)
        }
      } catch (error) {
        console.error('Error fetching shipping policy content:', error)
      } finally {
        setLoading(false)
      }
    }

    fetchContent()
  }, [])

  if (loading) {
    return (
      <div className="w-full max-w-[1920px] mx-auto px-4 sm:px-6 lg:px-8 xl:px-12 2xl:px-16 py-16">
        <div className="max-w-4xl mx-auto">
          <Skeleton className="h-12 w-1/3 mb-8" />
          <Skeleton className="h-4 w-1/4 mb-8" />
          <div className="space-y-4">
            <Skeleton className="h-8 w-1/2" />
            <Skeleton className="h-20 w-full" />
            <Skeleton className="h-8 w-1/3" />
            <Skeleton className="h-32 w-full" />
            <Skeleton className="h-8 w-1/2" />
            <Skeleton className="h-24 w-full" />
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="w-full max-w-[1920px] mx-auto px-4 sm:px-6 lg:px-8 xl:px-12 2xl:px-16 py-16">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl font-bold mb-4">
          {content?.title || "Shipping Policy"}
        </h1>
        <p className="text-sm text-muted-foreground mb-8">
          Written by the AEPAC Team
        </p>
        
        {content?.lastUpdated && (
          <p className="text-muted-foreground mb-8">
            Last updated: {formatDateIST(content.lastUpdated, { 
              year: 'numeric', 
              month: 'long', 
              day: 'numeric',
              timeZone: 'Asia/Kolkata'
            })}
          </p>
        )}

        {content?.content ? (
          <SafeHtml content={content.content} />
        ) : (
          <div className="prose prose-gray max-w-none text-pretty">
            <p className="text-muted-foreground">
              Shipping policy content is not available at the moment. Please check back later.
            </p>
          </div>
        )}
      </div>
    </div>
  )
}
